import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home.vue";

import MeasureList from "../views/MeasureList.vue";
import MeasureGraph from "../views/MeasureGraph.vue";
import MeasureEdit from "../views/MeasureEdit.vue";
import ConstructionSiteNew from "../views/ConstructionSiteNew.vue";
import ConstructionSiteIndex from "../views/ConstructionSiteIndex.vue";
import ConstructionSiteDetail from "../views/ConstructionSiteDetail.vue";
import ConstructionSiteEdit from "../views/ConstructionSiteEdit.vue";
import DeviceList from "../views/DeviceList.vue";
import UserList from "../views/UserList.vue";
import Login from "../views/Login.vue";
import Release from "../views/Release.vue";

import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:customer",
    name: "Home",
    component: Home,
    async beforeEnter(to, from, next) {
      store.commit("user/UPDATE_CUSTOMER", to.params.customer);
      await store.dispatch("user/getSession");

      if (store.state.user.isLoggedIn) {
        if (to.params.customer === store.state.user.customer) {
          next();
        } else {
          next(`/${store.state.user.customer}`);
        }
      } else {
        if (to.name === "Login") {
          next();
        } else {
          next({
            path: "/" + to.params.customer + "/login",
          });
        }
      }
    },
    children: [
      {
        path: "home",
        name: "MeasureList",
        component: MeasureList,
      },
      {
        path: "devices",
        name: "DeviceList",
        component: DeviceList,
        beforeEnter(to, from, next) {
          adminOnly(store.state.user.role, next);
        },
      },
      {
        path: "measures/:id(\\d+)",
        name: "MeasureGraph",
        component: MeasureGraph,
      },
      {
        path: "measures/:id(\\d+)/edit",
        name: "MeasureEdit",
        component: MeasureEdit,
      },
      {
        path: "construction_sites",
        name: "ConstructionSiteIndex",
        component: ConstructionSiteIndex,
      },
      {
        path: "construction_sites/new",
        name: "ConstructionSiteNew",
        component: ConstructionSiteNew,
      },
      {
        path: "construction_sites/:id(\\d+)",
        name: "ConstructionSiteDetail",
        component: ConstructionSiteDetail,
      },
      {
        path: "construction_sites/:id(\\d+)/edit",
        name: "ConstructionSiteEdit",
        component: ConstructionSiteEdit,
      },
      {
        path: "users",
        name: "UserList",
        component: UserList,
        beforeEnter(to, from, next) {
          adminOnly(store.state.user.role, next);
        },
      },
      {
        path: "release",
        name: "Release",
        component: Release,
      },
      {
        path: "",
        redirect: "home",
      },
    ],
  },
  {
    path: "/:customer/login",
    name: "Login",
    component: Login,
    async beforeEnter(to, from, next) {
      store.commit("user/UPDATE_CUSTOMER", to.params.customer);
      store.commit("user/UPDATE_IS_LOGGED_IN", false);

      if (store.state.user.isLoggedIn) {
        next(to.params.customer);
      } else {
        next();
      }
    },
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("@/views/NotFound.vue"),
    async beforeEnter(to, from, next) {
      await store.dispatch("user/getSession");
      if (store.state.user.customer) {
        next(store.state.user.customer);
      } else {
        next();
      }
    },
  },
];

const adminOnly = (role, next) => {
  if (role === "admin" || role === "system") {
    next();
  } else {
    next("");
  }
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
